import Phaser from "phaser";
import { StorageWindow } from "../windows/storage-window";

export class StorageScreen {

  private readonly storageWindow: StorageWindow;
  private readonly panel: Phaser.GameObjects.Container;

  constructor(
    scene: Phaser.Scene,
    _windowManager: any,
    panel: Phaser.GameObjects.Container,
  ) {
    this.panel = panel;
    this.storageWindow = new StorageWindow(scene);
    this.storageWindow.setLayoutMode("fullscreen");
    this.storageWindow.setShowSellButton(true);
  }

  // Refresh the storage window display with latest data
  refresh(): void {
    if (this.storageWindow && typeof this.storageWindow.refresh === "function") {
      this.storageWindow.refresh();
    }
  }

  show(): void {
    this.storageWindow.setScreenContainer(this.panel);
    this.storageWindow.show();
    
    // Request fresh storage data from server
    if ((window as any).socket) {
      (window as any).socket.emit("open-chest");
    }
  }

  hide(): void {
    this.storageWindow.hide();
  }
}
